var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatospersonales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #00dbdc;\r\n        opacity: .1;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #04808f;\r\n      }\r\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.76,
    cy: 15.31,
    r: 11.54
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.02,15.01c3.31,0,6-2.69,6-6s-2.69-6-6-6-6,2.69-6,6,2.69,6,6,6Zm0-11c2.76,0,5,2.24,5,5s-2.24,5-5,5-5-2.24-5-5,2.24-5,5-5Zm8,18v5h-1v-5c0-2.21-1.79-4-4-4h-6c-2.21,0-4,1.79-4,4v5h-1v-5c0-2.76,2.24-5,5-5h6c2.76,0,5,2.24,5,5Zm7.98-9.83l-5.33,5.35c-.32,.32-.73,.48-1.15,.48s-.83-.16-1.15-.48l-3.15-3.15,.71-.71,3.14,3.14c.24,.24,.65,.24,.89,0l5.33-5.35,.71,.71h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatospersonales);
export default __webpack_public_path__ + "static/media/Datospersonales.81f855b5199e21b6bfc0988ab8e76acb.svg";
export { ForwardRef as ReactComponent };